import { KYMW1001Model } from '../../kymw/kymw10/kymw1001/kymw1001.model';
import { KYMW1002Model } from '../../kymw/kymw10/kymw1002/kymw1002.model';
import { Injectable } from "@angular/core";

/**
 * 共通モデルクラス
 *
 * @export KYMW00Model
 * @class KYMW00Model
 */
@Injectable()
export class KYMW00Model {

  public static DISABLED_BG_COLOR: string = getComputedStyle(document.documentElement).getPropertyValue('--disable-bg-color');

  // トップ画面モデルクラス
  public kymw1001Model: KYMW1001Model = new KYMW1001Model();
  // ダッシュボード画面モデルクラス
  public kymw1002Model: KYMW1002Model = new KYMW1002Model();

  /**
   * ポップアップウィンドウ自体を保持している配列。<br/>
   * IFlexDisplayObject型のみとする。
   */
  public popUpWinList: Array<string> = new Array<string>();

  // ロックタイプ
  // 企画商品ロック
  public readonly EVENT_LOCK_PLAN_GOODS_CHECK: string = String('EVENT_LOCK_PLAN_GOODS_CHECK');
  public readonly EVENT_LOCK_PLAN_GOODS_REGIST: string = String('EVENT_LOCK_PLAN_GOODS_REGIST');
  public readonly EVENT_LOCK_PLAN_GOODS_REGIST_SUCCESS: string = String('EVENT_LOCK_PLAN_GOODS_REGIST_SUCCESS');
  public readonly EVENT_LOCK_PLAN_GOODS_REGIST_FAULT: string = String('EVENT_LOCK_PLAN_GOODS_REGIST_FAULT');
  public readonly EVENT_LOCK_PLAN_GOODS_RELEASE: string = String('EVENT_LOCK_PLAN_GOODS_RELEASE');

  // 企画ロック
  public readonly EVENT_LOCK_CATALOG_CHECK: string = String('EVENT_LOCK_CATALOG_CHECK');
  public readonly EVENT_LOCK_CATALOG_REGIST: string = String('EVENT_LOCK_CATALOG_REGIST');
  public readonly EVENT_LOCK_CATALOG_REGIST_WITH_FORCE_RELEASE: string = String('EVENT_LOCK_CATALOG_REGIST_WITH_FORCE_RELEASE');
  public readonly EVENT_LOCK_CATALOG_REGIST_SUCCESS: string = String('EVENT_LOCK_CATALOG_REGIST_SUCCESS');
  public readonly EVENT_LOCK_CATALOG_REGIST_FAULT: string = String('EVENT_LOCK_CATALOG_REGIST_FAULT');
  public readonly EVENT_LOCK_CATALOG_RELEASE: string = String('EVENT_LOCK_CATALOG_RELEASE');

  // ページロック
  public readonly EVENT_LOCK_PAGE_CHECK: string = String('EVENT_LOCK_PAGE_CHECK');
  public readonly EVENT_LOCK_PAGE_REGIST: string = String('EVENT_LOCK_PAGE_REGIST');
  public readonly EVENT_LOCK_PAGE_REGIST_SUCCESS: string = String('EVENT_LOCK_PAGE_REGIST_SUCCESS');
  public readonly EVENT_LOCK_PAGE_REGIST_FAULT: string = String('EVENT_LOCK_PAGE_REGIST_FAULT');
  public readonly EVENT_LOCK_PAGE_RELEASE: string = String('EVENT_LOCK_PAGE_RELEASE');

  // 生協コード
  public readonly COOP_CODE_IB: string = <string>'142';                         // いばらき
  public readonly COOP_CODE_TO: string = <string>'163';                         // とちぎ
  public readonly COOP_CODE_GU: string = <string>'185';                         // ぐんま
  public readonly COOP_CODE_TI: string = <string>'240';                         // ちば
  public readonly COOP_CODE_SA: string = <string>'210';                         // さいたま
  public readonly COOP_CODE_TK: string = <string>'302';                         // とうきょう
  public readonly COOP_CODE_NA: string = <string>'515';                         // ながの
  public readonly COOP_CODE_NI: string = <string>'451';                         // にいがた
  public readonly COOP_CODE_KU: string = <string>'454';                         // クルコ

  // 生協名
  public readonly COOP_IB: string = <string>'いばらき';
  public readonly COOP_TO: string = <string>'とちぎ';
  public readonly COOP_GU: string = <string>'ぐんま';
  public readonly COOP_TI: string = <string>'ちば';
  public readonly COOP_SA: string = <string>'さいたま';
  public readonly COOP_TK: string = <string>'とうきょう';
  public readonly COOP_NA: string = <string>'ながの';
  public readonly COOP_NI: string = <string>'にいがた';
  public readonly COOP_KU: string = <string>'クルコ';

  // 生協コード: 生協名
  public readonly COOP_MAP = {
    '142': this.COOP_IB,
    '163': this.COOP_TO,
    '185': this.COOP_GU,
    '240': this.COOP_TI,
    '210': this.COOP_SA,
    '302': this.COOP_TK,
    '515': this.COOP_NA,
    '451': this.COOP_NI,
  }

  // 媒体グループ区分
  public readonly MEDIUM_GROUP_DIV_NORMAL: string = <string>'01';               // 通常媒体
  public readonly MEDIUM_GROUP_DIV_NVAL: string = <string>'02';                 // 1物N価媒体
  public readonly MEDIUM_GROUP_DIV_COUPON: string = <string>'03';               // クーポン媒体
  public readonly MEDIUM_GROUP_DIV_POINT: string = <string>'04';                // ポイント交換媒体
  public readonly MEDIUM_GROUP_DIV_PREORDER: string = <string>'05';             // 予約媒体
  public readonly MEDIUM_GROUP_DIV_REMEMBER: string = <string>'06';             // 忘れず注文媒体
  public readonly MEDIUM_GROUP_DIV_OPERATION: string = <string>'07';            // 運営商品媒体
  public readonly MEDIUM_GROUP_DIV_ORDERUNIT: string = <string>'08';            // 注文単位値引きクーポン媒体
  public readonly MEDIUM_GROUP_DIV_CARROT: string = <string>'09';               // キャロット媒体
  public readonly MEDIUM_GROUP_DIV_STOCK: string = <string>'10';                // 在庫限定

  // 業態区分
  public readonly DUTIES_FORM_DIV_WEEKLY: string = <string>'1';                 // ウィークリー
  public readonly DUTIES_FORM_DIV_DAILY: string = <string>'2';                  // デイリー
  public readonly DUTIES_FORM_DIV_SPOT: string = <string>'3';                   // スポット
  public readonly DUTIES_FORM_DIV_PERIOD: string = <string>'0';                 // 期間（いつでも注文）

  // 権限区分
  public readonly FUNC_PERMISSION_DISABLE: string = String('0');                // 使用不可
  public readonly FUNC_PERMISSION_READONLY: string = String('1');               // 閲覧のみ
  public readonly FUNC_PERMISSION_FULLCONTROL: string = String('2');            // フルコントロール可能

  /** ユーザ区分 取引先 */
  public static readonly ASSOCIATED_USER_TYPE_SUPPLIER: string = <string>'1';
  /** ユーザ区分 スタジオ */
  public static readonly ASSOCIATED_USER_TYPE_STUDIO: string = <string>'2';
  /** ユーザ区分 制作会社 */
  public static readonly ASSOCIATED_USER_TYPE_PRODUCTION: string = <string>'3';

  /** 企画支援会社フラグ */
  public static readonly PLANNING_SUPPORT_TRUE: string = <string>'1';

  /** 付加タブ項目説明 */
  public readonly EXPLAIN_EC_GOODS: string = <string>'ECのみに表示する情報です';  // EC用商品説明
  public readonly EXPLAIN_E_FRIENDS: string = <string>'ECのみに表示する情報です';  // 便利情報(eフレンズ)
  public readonly EXPLAIN_SIZE: string = <string>'「直径」「長さ」「高さ」などを先頭に入れます';  // 便利情報(サイズ他)
  public readonly EXPLAIN_MONTH_OLD: string = <string>'包材に月齢表示がある場合はこの欄にその情報を入力します';  // 便利情報(月齢情報)
  public readonly EXPLAIN_POPULAR_GOODS: string = <string>'人気ベストに関する情報です';  // 人気商品情報
  public readonly EXPLAIN_HEALTH_MANAGE: string = <string>'減塩量（塩分カット量）・糖質量・鉄分・食物繊維など強化栄養素の情報を入れます';  // 健康管理情報
  public readonly EXPLAIN_INGREDIENTS: string = <string>'化粧品など住関連部門で使用する情報です';  // 成分情報
  public readonly EXPLAIN_WATER_ABSORPTION: string = <string>'吸水ケア製品・大人用おむつなどの情報です';  // 吸水量
  public readonly EXPLAIN_COOKING_TIME: string = <string>'ミールキット(16部門)で使用する情報です';  // 調理時間の目安
  public readonly EXPLAIN_SERVINGS: string = <string>'ミールキット(16部門)で使用する情報です';  // 〇人前情報
  public readonly EXPLAIN_MATERIAL: string = <string>'ミールキット(16部門)で使用する情報です';  // 材料
  public readonly EXPLAIN_PREPARATION: string = <string>'ミールキット(16部門)で使用する情報です';  // ご家庭で用意いただくもの

  /**
   * 文字列の前後についている空白を除外するメソッド
   * @param param 対象文字列
   * @returns 除外後の文字列を返す
   */
  public deleteStartAndEndSpace(param: string): string {
    let targetParam = param ? param : '';
    const startChar = targetParam.charAt(0);
    // 文字列の最初に空白があれば削除
    if (startChar === ' ' || startChar === '　') {
      targetParam = targetParam.slice(1);
    }
    const endChar = targetParam.charAt(targetParam.length - 1);
    // 文字列の最後肉薄があれば削除
    if (endChar === ' ' || endChar === '　') {
      targetParam = targetParam.slice(0, -1);
    }

    return targetParam;
  }
}
